export type DsListingToolbarSortOption = {
  value: number;
  label: string;
};

export type DsListingToolbarProps = {
  count: number;
  countLabel: string;
  sortValue: number;
  sortOptions: DsListingToolbarSortOption[];
  onSortChange: (value: number) => void;
  sortName?: string;
  className?: string;
};

export function DsListingToolbar({
  count,
  countLabel,
  sortValue,
  sortOptions,
  onSortChange,
  sortName = "sortare",
  className
}: DsListingToolbarProps) {
  const cls = ["cc-ds-listToolbar", "bx-listToolbar", className || ""].filter(Boolean).join(" ");
  return (
    <div id="sortareProduse" className={cls}>
      <span className="cc-ds-listToolbar__count bx-listToolbar__count">
        <b>{count}</b> {countLabel}
      </span>
      <label className="cc-ds-listToolbar__sort bx-listToolbar__sort">
        <i className="fa fa-sort" aria-hidden="true" />
        <select value={sortValue} onChange={(e) => onSortChange(Number(e.target.value))} name={sortName}>
          {sortOptions.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      </label>
    </div>
  );
}
